export default "__VITE_PUBLIC_ASSET__dd2b67d7__"